import React from "react";
import useDebounce from "hooks/useDebounce";
import { refreshIcon } from "assets/index";

// Компонент кнопки оновлення таблиці
const RefreshButton = React.memo(({ onRefresh, disabled }) => {
  const debouncedOnClick = useDebounce(onRefresh, 300);

  return (
    <button
      className="focus-button"
      onClick={debouncedOnClick}
      disabled={disabled}
      title="Оновлення таблиці"
    >
      <img className="icon" src={refreshIcon} alt="Оновлення таблиці" />
    </button>
  );
});

export default RefreshButton;
